<template>
  <div class="home-search" :class="{'home-search--mobile': deviceType === 'mobile'}">
    <div class="home-search__container">
      <div class="home-search__card">
        <h2 class="home-search__title">Search for your favorite car</h2>

        <div class="home-search__form">
          <div class="home-search__inputs">
            <!-- 类型选择 -->
            <div class="home-search__input-item" @click.stop="toggleDropdown('type')">
              <div class="home-search__input-content">
                <img src="@/assets/homehero/Model.svg" class="home-search__input-icon" alt="type">
                <span class="home-search__input-text">{{ selectedType.name }}</span>
              </div>
              <img src="@/assets/homehero/arow-down.svg" class="home-search__input-arrow"
                :class="{'home-search__input-arrow--rotated': activeDropdown === 'type'}"
                alt="arrow">

              <div class="home-search__dropdown" v-show="activeDropdown === 'type'">
                <div v-for="(item, index) in types" :key="index" class="home-search__dropdown-item"
                  :class="{'home-search__dropdown-item--active': selectedType.id === item.id}"
                  @click.stop="selectItem('type', item)">
                  {{ item.name }}
                </div>
              </div>
            </div>

            <!-- 价格选择 -->
            <div class="home-search__input-item" @click.stop="toggleDropdown('price')">
              <div class="home-search__input-content">
                <img src="@/assets/homehero/Budget.svg" class="home-search__input-icon" alt="price">
                <span class="home-search__input-text">{{ selectedPrice.name }}</span>
              </div>
              <img src="@/assets/homehero/arow-down.svg" class="home-search__input-arrow"
                :class="{'home-search__input-arrow--rotated': activeDropdown === 'price'}"
                alt="arrow">

              <div class="home-search__dropdown" v-show="activeDropdown === 'price'">
                <div v-for="(item, index) in prices" :key="index" class="home-search__dropdown-item"
                  :class="{'home-search__dropdown-item--active': selectedPrice.id === item.id}"
                  @click.stop="selectItem('price', item)">
                  {{ item.name }}
                </div>
              </div>
            </div>

            <!-- 品牌选择 -->
            <div class="home-search__input-item" @click.stop="toggleDropdown('brand')">
              <div class="home-search__input-content">
                <img src="@/assets/homehero/Brand.svg" class="home-search__input-icon" alt="brand">
                <span class="home-search__input-text">{{ selectedBrand.name }}</span>
              </div>
              <img src="@/assets/homehero/arow-down.svg" class="home-search__input-arrow"
                :class="{'home-search__input-arrow--rotated': activeDropdown === 'brand'}"
                alt="arrow">

              <div class="home-search__dropdown" v-show="activeDropdown === 'brand'">
                <div v-for="(item, index) in brands" :key="index" class="home-search__dropdown-item"
                  :class="{'home-search__dropdown-item--active': selectedBrand.id === item.id}"
                  @click.stop="selectItem('brand', item)">
                  {{ item.name }}
                </div>
              </div>
            </div>
          </div>

          <a class="home-search__btn" :href="searchHref">
            <img src="@/assets/search.svg" class="home-search__btn-icon" alt="search">
            <span>Search</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'HomeSearch',
  data () {
    return {
      activeDropdown: null,
      types: [
        { id: 'all-types', name: 'All Types' },
        { id: 'Sedan', name: 'Sedan' },
        { id: 'SUV', name: 'SUV' },
        { id: 'Coupe', name: 'Coupe' },
        { id: 'Hatchback', name: 'Hatchback' },
        { id: 'Wagon', name: 'Wagon' },
        { id: 'Pickup Truck', name: 'Pickup Truck' },
        { id: 'Van', name: 'Van' },
        { id: 'Convertible', name: 'Convertible' }
      ],
      selectedType: { id: 'all-types', name: 'All Types' },
      prices: [
        { id: 'all-prices', name: 'All Ex-Showroom Price' },
        { id: 'less_20000', name: 'Less than $20,000' },
        { id: '20001_40000', name: '$20,001 - $40,000' },
        { id: '40001_60000', name: '$40,001 - $60,000' },
        { id: '60001_80000', name: '$60,001 - $80,000' },
        { id: 'more_80001', name: 'More than $80,000' }
      ],
      selectedPrice: { id: 'all-prices', name: 'All Ex-Showroom Price' },
      brands: [
        { id: 'all-brands', name: 'All Brands' },
        { id: 'Acura', name: 'Acura' },
        { id: 'Audi', name: 'Audi' },
        { id: 'BMW', name: 'BMW' },
        { id: 'Cadillac', name: 'Cadillac' },
        { id: 'Chevrolet', name: 'Chevrolet' },
        { id: 'Ford', name: 'Ford' },
        { id: 'Honda', name: 'Honda' },
        { id: 'Toyota', name: 'Toyota' }
      ],
      selectedBrand: { id: 'all-brands', name: 'All Brands' }
    };
  },
  computed: {
    ...mapGetters(['deviceType', 'domainConfig']),
    searchHref () {
      const searchParams = {};
      if (this.selectedType.id !== 'all-types') searchParams.type = this.selectedType.id;
      if (this.selectedPrice.id !== 'all-prices') {
        const id = this.selectedPrice.id;
        if (id === 'less_20000') searchParams.mostPrice = 20000;
        else if (id === 'more_80001') searchParams.leastPrice = 80001;
        else {
          const parts = id.split('_');
          searchParams.leastPrice = parts[0];
          searchParams.mostPrice = parts[1];
        }
      }
      if (this.selectedBrand.id !== 'all-brands') searchParams.brand = this.selectedBrand.id;

      const channel = this.$route.params.channel;
      const query = new URLSearchParams(searchParams).toString();
      const path = channel ? `/${channel}/car-list` : '/car-list';
      return `${path}${query ? '?' + query : ''}`;
    }
  },
  mounted () {
    document.addEventListener('click', this.closeDropdowns);
  },
  beforeDestroy () {
    document.removeEventListener('click', this.closeDropdowns);
  },
  methods: {
    toggleDropdown (type) {
      this.activeDropdown = this.activeDropdown === type ? null : type;
    },
    closeDropdowns () {
      this.activeDropdown = null;
    },
    selectItem (type, item) {
      if (type === 'type') this.selectedType = item;
      else if (type === 'price') this.selectedPrice = item;
      else if (type === 'brand') this.selectedBrand = item;
      this.activeDropdown = null;
    }
  }
};
</script>

<style lang="scss">
@import '~@/css/variables.scss';

.home-search {
	background: #000;
	padding: rem(60) rem(180);
	width: 100%;
	box-sizing: border-box;

	&__card {
		background: linear-gradient(180deg, rgba(226, 55, 45, 0) 0%, rgba(226, 55, 45, 0.2) 100%);
		border-radius: rem(16);
		border: 1px solid var(--Linear, rgba(255, 255, 255, 0.2));
		padding: rem(40);
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: rem(40);
	}

	&__title {
		color: #e2372d;
		font-family: 'Inter-ExtraBold', sans-serif;
		font-size: rem(40);
		font-weight: 800;
		text-decoration: underline;
		margin: 0;
		text-align: center;
	}

	&__form {
		background: rgba(255, 255, 255, 0.1);
		border-radius: rem(16);
		border: 1px solid rgba(255, 255, 255, 0.1);
		padding: rem(8);
		display: flex;
		align-items: center;
		gap: rem(8);
		width: 100%;
		backdrop-filter: blur(10px);
	}

	&__inputs {
		display: flex;
		gap: rem(8);
		flex: 1;
	}

	&__input-item {
		flex: 1;
		background: #ffffff;
		border-radius: rem(12);
		padding: rem(16) rem(12);
		display: flex;
		align-items: center;
		justify-content: space-between;
		cursor: pointer;
		position: relative;
		box-shadow: 0 rem(4) rem(12) rgba(0, 0, 0, 0.24);
	}

	&__input-content {
		display: flex;
		align-items: center;
		gap: rem(8);
	}

	&__input-icon {
		width: rem(12);
		height: rem(12);
	}

	&__input-text {
		color: #000000;
		font-family: 'Inter-Medium', sans-serif;
		font-size: rem(12);
		font-weight: 500;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	&__input-arrow {
		width: rem(8);
		transition: transform 0.3s ease;
		&--rotated {
			transform: rotate(180deg);
		}
	}

	&__dropdown {
		position: absolute;
		top: 110%;
		left: 0;
		width: 100%;
		background: #ffffff;
		border-radius: rem(8);
		box-shadow: 0 rem(4) rem(12) rgba(0, 0, 0, 0.16);
		z-index: 100;
		max-height: rem(210);
		overflow-y: auto;
	}

	&__dropdown-item {
		padding: rem(12) rem(16);
		color: #000;
		font-size: rem(12);
		border-bottom: 1px solid #f5f5f5;
		&:hover {
			background: #fdf2f2;
		}
		&--active {
			color: #e2372d;
			font-weight: 700;
		}
	}

	&__btn {
		background: #e2372d;
		border-radius: rem(12);
		padding: rem(16) rem(32);
		display: flex;
		align-items: center;
		justify-content: center;
		gap: rem(12);
		width: rem(196);
		text-decoration: none;
		box-shadow: 0 rem(4) rem(12) rgba(0, 0, 0, 0.24);
		transition: all 0.3s ease;

		span {
			color: #ffffff;
			font-family: 'Inter-ExtraBold', sans-serif;
			font-size: rem(14);
			font-weight: 800;
		}

		&:hover {
			opacity: 0.9;
			transform: translateY(-2px);
		}
	}

	&__btn-icon {
		width: rem(14);
		height: rem(14);
		filter: brightness(0) invert(1);
	}
}

// PC端基础样式
.detect_deviece_pc,
.detect_deviece_desktop {
	.home-search {
		padding: rem(60) rem(180);
		&__form {
			flex-direction: row;
		}
	}
}

// 移动端基础样式
.detect_deviece_mobile {
	.home-search {
		padding: rem(60) rem(16);
		&__card {
			padding: rem(30) rem(16);
			gap: rem(30);
		}
		&__title {
			font-size: rem(28);
			color: #e2372d;
			text-align: center;
			font-size: rem(40);
			font-style: normal;
			font-weight: 800;
			line-height: rem(52); /* 130% */
			text-decoration-line: underline;
			text-decoration-style: solid;
			text-decoration-skip-ink: auto;
			text-decoration-thickness: auto;
			text-underline-offset: auto;
			text-underline-position: from-font;
		}
		&__form {
			flex-direction: column;
			background: transparent;
			border: none;
			padding: 0;
			backdrop-filter: none;
		}
		&__inputs {
			flex-direction: column;
			width: 100%;
		}
		&__input-item {
			width: 100%;
		}
		&__btn {
			width: 100%;
		}
	}
}
</style>